import { DayOfWeek } from '../../organisms/Calendar';

// Filter function to remove weekends from the dates the main calendar displays
export const removeWeekends = (date) => {
  return date.day() !== DayOfWeek.Sunday && date.day() !== DayOfWeek.Saturday;
};
